import React,{useState} from "react";

import city_vh from '../../../models/cities_vh.json';

// Page Comp:
import TglButtonGroup from "../../../components/UI Components/Inputs/TglButtonGroup";
import ReactSelect from "../../../components/UI Components/Inputs/ReactSelect";
import ColapsePanel from "../../../components/UI Components/Panels/ColapsePanel";

// MUI Components
import Box     from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

// Styled comp:
import { styled } from '@mui/material/styles';
import { ToggleButton, Typography } from "@mui/material";

/******************************************************
 * Component Style
******************************************************/

    const SectionTitle = styled(Typography) ({
        width:'100%',
        fontWeight:'bold',
        marginBottom:'0.3rem'
    });

    const ControlLabel = styled(Typography) ({
        width:'100%'
    });

    const CustTextFld =  styled(TextField) ({
        width:'100%',
        size:'small'
    });

    const CustToggleBtn = styled(ToggleButton) ({
        width:'6rem'
    })

    const InputContainer = styled(FormControl) ({
        width:'100%',
        [`& ${ControlLabel}`]: ({}),
        [`& ${CustTextFld}`]: ({})
    })
    
    const SectionContainer =  styled(Box)({
        width:'100%',
        marginTop:'1rem',
        marginBottom:'1rem',
        [`& ${InputContainer}`]: ({})
    })

    function GeneralDetView({handleChange, oEntry}) {
        console.log("general view");

        // const [oCity,setCity]       = useState(undefined),
        // const [price,setPrice]        = useState(undefined),
          const    [availDate,setAvailDate] = useState(new Date());

        const onToogleChange = (oEvent) => {
            // setPrice(oEvent.target.value);
            // handleChange(oEvent);
            // console.log(price)
        }


        return(
            <SectionContainer >        
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 3 }} disableGutters>
                    <SectionTitle variant="h5">General Details</SectionTitle>
                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}} component={'form'}>
                        <InputContainer>
                            <ControlLabel>type</ControlLabel>
                            <TglButtonGroup
                                onToogleChange={handleChange}
                                value={oEntry.objectType}>  
                                <CustToggleBtn value="01"   name="objectType">rent</CustToggleBtn>
                                <CustToggleBtn value="02"  name="objectType" >service</CustToggleBtn>
                                <CustToggleBtn value="03"  name="objectType" >product</CustToggleBtn>
                            </TglButtonGroup>
                        </InputContainer>
                    </Grid>
                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}} component={'form'}>
                        <InputContainer>
                            <ControlLabel>city</ControlLabel>
                            <ReactSelect
                                // key='crt_city'
                                name="city" 
                                isMulti={false}
                                isClearable={true} 
                                options={city_vh}
                                value={oEntry.oCity} 
                                handleChange={(oEvent) => handleChange(oEvent, 'city')}/>

                        </InputContainer>
                    </Grid>
                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}} component={'form'}>
                        <InputContainer>
                            <ControlLabel>Price</ControlLabel>
                             <CustTextFld
                                key="crt_price"
                                name="price"
                                value={oEntry.price}
                                onChange={handleChange}
                                type="number"
                                size="small"/>
                        </InputContainer>
                    </Grid>

                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>Nliving space</ControlLabel>
                             <CustTextFld
                                key="crt_livSpace"
                                name="livingSpace"
                                value={oEntry.livingSpace}
                                onChange={handleChange}
                                type="number"
                                size="small"/>
                        </InputContainer>
                    </Grid>

                   <Grid size={{xs: 12, sm:6, md: 6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>Number of Rooms</ControlLabel>
                             <CustTextFld
                                key="crt_numRoom"
                                name="numberOfRooms"
                                value={oEntry.numberOfRooms}
                                onChange={handleChange}
                                type="number"
                                size="small"/>
                        </InputContainer>
                    </Grid>
                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>Number of Bathrooms</ControlLabel>
                             <CustTextFld
                                key="crt_numBRoom"
                                name="numberOfBathrooms"
                                value={oEntry.numberOfBathrooms}
                                onChange={handleChange} 
                                type="number"
                                size="small"/>
                        </InputContainer>
                    </Grid>

                    <Grid size={{xs: 12, sm:6, md: 6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>availability date</ControlLabel>
                             <CustTextFld
                                key="crt_availDate"
                                name="availabilityDate"
                                value={oEntry.availabilityDate}
                                onChange={handleChange}
                                type="date"
                                size="small"
                                />
                        </InputContainer>
                    </Grid>
                </Grid>
            </SectionContainer>
        );
    }

export default GeneralDetView;